import React, { Suspense, lazy, useEffect, useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Helmet } from "react-helmet"

import LoadingComponent from '../base/components/loading'
import ScrollToTop from '../base/components/scroll-to-top'

import { getRoutes } from './routes'
import PageViewTracker from './page-view-tracker'
import { registerUserContext } from './mixpanel'
import { ToastProvider } from 'react-toast-notifications'
import { switchTenant } from './services/apis'
import { authService } from '../base/services'
import { path } from 'ramda'
import { clearCustomerFiltersOnStorage } from './services/local_storage/customer-filters-storage'

const NotFoundPage = lazy(() => import('./scenes/not-found'))

const App = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const routes = getRoutes()

  useEffect(() => {
    const handleTenantSwitch = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const tenantId = urlParams.get('switchTenantId');
      
      if (tenantId) {
        try {
          const result = await switchTenant(tenantId);

          authService.authenticate({
            account: path(["data", 1, "user"], result),
            accessToken: path(["data", 1, "token"], result),
            refreshToken: path(["data", 1, "refreshToken"], result),
            tenant_info: path(["data", 1, "tenant_info"], result),
          });

          clearCustomerFiltersOnStorage();

          // Re-seed the Mixpanel super properties, otherwise every event after
          // the switch is still attributed to the previous tenant.
          registerUserContext();

          window.dispatchEvent(new CustomEvent('tenantInfoUpdated'));
          
          const newUrl = new URL(window.location);
          newUrl.searchParams.delete('switchTenantId');
          window.history.replaceState({}, '', newUrl.toString());
          
        } catch (error) {
          console.error('Error switching tenant from URL:', error);
        }
      }
      
      setIsInitialized(true);
    };

    handleTenantSwitch();
  }, []);

  if (!isInitialized) {
    return <LoadingComponent />;
  }

  return (
    <ToastProvider>
      <Helmet>
        <title>Aquo</title>
      </Helmet>
      <Router>
        <ScrollToTop>
          {/* ScrollToTop returns props.children as-is, so keep it a single node. */}
          <>
            <PageViewTracker />
            <Suspense
              fallback={<LoadingComponent />}
            >
              <Switch>
                {routes.map(({ layout: Layout, ...otherParams }, i) => (
                  <Layout
                    {...otherParams}
                    key={i + ''}
                  />
                ))}
                {/*<Route component={NotFoundPage} />*/}
              </Switch>
            </Suspense>
          </>
        </ScrollToTop>
      </Router>
    </ToastProvider>
  )
}

export default App